<h4> {{ 'CHANGES' | translate }} </h4>

<mat-dialog-content>
  <app-fv-order-changes-table [data]="tableData"></app-fv-order-changes-table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="makeReview()"> {{ 'REVIEWED' | translate }} </button>
</mat-dialog-actions>